import { PinnedItem } from '~/types/platform/platform';
import { UniqItem, Item } from '~/types/store/item';
import { getDoc, doc } from 'firebase/firestore';
import { firestore } from '~/firebase/init';

export default async function getPinnedItems(
  pinnedItems: Array<PinnedItem>,
): Promise<Array<UniqItem>> {
  const res = await Promise.all(
    pinnedItems.map(({ storeId, itemId }) => {
      const ref = doc(firestore, `stores`, storeId, 'items', itemId);
      return getDoc(ref);
    }),
  );

  return res
    .filter((doc) => doc.exists())
    .map((doc) => ({
      id: doc.id,
      uniqId: `${doc.ref.parent.parent?.id || ''}${doc.id}`,
      storeId: doc.ref.parent.parent?.id || '',
      ...(doc.data() as Item),
    }));
}
